import Normal from './normal.svg';
import Precise from './precise.svg';
import Single from './single.svg';

export default {
  Normal,
  Precise,
  Single,
};
